export default __webpack_public_path__ + "static/media/toy-packages.3cdb4f6b.png";